import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyReservationComponent } from './property-reservation.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { LoadersModule } from 'app/main/shared/modules/loaders/loaders.module';




@NgModule({
  declarations: [PropertyReservationComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    LoadersModule

  ]
})
export class PropertyReservationModule { }
